/* Theme-local accessible product-group menus. Mobile uses the theme drawer. */
class GarageMenu extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.onToggle = () => {
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      if (this.details.open) document.querySelectorAll('garage-menu').forEach(menu => {
        if (menu !== this) menu.close();
      });
    };
    this.onOutside = event => { if (!this.contains(event.target)) this.close(); };
    this.onKey = event => {
      if (event.key === 'Escape' && this.details.open) {
        event.preventDefault(); this.close(); this.summary.focus();
      }
    };
    this.onFocus = event => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    };
    this.summary.setAttribute('aria-expanded', String(this.details.open));
    this.summary.setAttribute('aria-controls', this.summary.nextElementSibling.id);
    this.details.addEventListener('toggle', this.onToggle);
    this.addEventListener('keydown', this.onKey);
    this.addEventListener('focusout', this.onFocus);
    document.addEventListener('pointerdown', this.onOutside);
  }
  close() { this.details.open = false; this.summary.setAttribute('aria-expanded', 'false'); }
  disconnectedCallback() {
    this.details.removeEventListener('toggle', this.onToggle);
    this.removeEventListener('keydown', this.onKey);
    this.removeEventListener('focusout', this.onFocus);
    document.removeEventListener('pointerdown', this.onOutside);
    this.bound = false;
  }
}
if (!customElements.get('garage-menu')) customElements.define('garage-menu', GarageMenu);

// A followed menu link should not leave a drawer covering the page after Back.
function closeGarageDrawer() {
  const details = document.querySelector('#Details-menu-drawer-container');
  if (details?.open) details.querySelector('summary').click();
}
document.addEventListener('click', event => {
  if (event.target.closest('#menu-drawer .garage-menu-link')) closeGarageDrawer();
});
window.addEventListener('pageshow', event => { if (event.persisted) closeGarageDrawer(); });
